import { ContentViewStyle } from '@levelapp/softfabric';
export default class TableViewStyle extends ContentViewStyle {
    constructor() {
        super(...arguments);
        this.thRow = {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            borderBottomWidth: 1,
            paddingTop: 12,
            paddingBottom: 12,
            borderColor: '#e0e0e0',
        };
        this.tdRow = {
            display: 'flex',
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'space-between',
            borderBottomWidth: 1,
            paddingTop: 12,
            paddingBottom: 12,
            borderColor: '#e0e0e0',
        };
        this.thText = {
            color: 'black',
            fontWeight: 'bold',
            fontSize: 15,
        };
        this.tdText = {
            color: '#3f3f3f',
            fontWeight: '300',
            flexWrap: 'wrap',
        };
        this.textinput = {
            borderColor: '#d3dbe8',
            borderWidth: 1,
            borderRadius: 5,
        };
        this.showImage = {
            opacity: 1,
            marginLeft: 5,
            alignSelf: 'center',
            height: 12,
            width: 12
        };
        this.notShowingImage = {
            opacity: 0,
        };
        this.containerResearch = {
            flexDirection: 'row',
        };
        this.containerButton = {
            zIndex: 150,
            alignSelf: 'center',
            flexDirection: 'row',
            marginBottom: 15,
            marginLeft: 5,
            marginRight: 5,
        };
        this.containerExport = {
            flexDirection: 'row',
            justifyContent: 'center',
        };
        this.containerAdding = {
            flexDirection: 'row',
        };
        this.aboveHeader = {
            flex: 1,
            marginBottom: 15,
            flexDirection: 'column',
            justifyContent: 'flex-start',
        };
        this.nothingToDisplay = {
            flex: 1,
            marginTop: 15,
            alignItems: 'center',
        };
        this.buttonStyle = {
            height: 25,
            width: 70,
        };
        this.noHeadersResults = {
            flex: 1,
        };
        this.centerText = {
            alignSelf: 'center',
        };
        this.borderTheChoice = {
            borderRadius: 5,
            width: 40
        };
        this.NoButton = {
            backgroundColor: '#4154d2',
        };
        this.YesButton = {
            backgroundColor: '#d25941',
        };
        this.choiceYesText = {
            color: 'black',
            fontWeight: 'bold',
            textAlign: 'center',
        };
        this.choiceNoText = {
            color: 'white',
            fontWeight: 'bold',
            textAlign: 'center',
        };
        this.textInputAddNewColumn = {
            borderColor: 'gray',
            borderWidth: 1,
            borderRadius: 5,
        };
    }
}
